import {useDispatch, useSelector} from 'react-redux'
import {
  FilterKey,
  FilterSource
} from 'components/Accommodation/OffersFilters/constants'
import {getSelectedFiltersMap} from 'components/Accommodation/OffersFilters/getSelectedFilters'
import {useUrlUpdater} from 'components/data/WithUrlUpdater'
import {getAccommodationPageOfferFilters} from 'modules/accommodation/selectors'
import {getOverlay} from 'modules/overlay/selectors'
import {getUrlParams} from 'modules/search/selectors'

import {useRouterProvider} from '@vio/core/src/_web/router/context/RouterContext'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'

export const useHotelOverlayOffersFilters = () => {
  const dispatch = useDispatch()
  const overlayState = useSelector(getOverlay)
  const activeOffersFilters = useSelector(getAccommodationPageOfferFilters)
  const urlParams = useSelector(getUrlParams)
  const {pathname} = useRouterProvider()
  const {updateLocation} = useUrlUpdater()
  /**
   * Set (or remove) multiple filters
   */
  const setFilters = (filters: FilterKey[], source?: FilterSource) => {
    if (source)
      dispatch(
        trackEvent({
          category: Category.User,
          entity: Entity.OfferFilterPreference,
          action: Action.Submitted,
          payload: {
            allSelectedFilters: getSelectedFiltersMap(filters),
            appliedFiltersFrom: source
          }
        })
      )
    const newParams = {...urlParams, offerFilters: filters.join(',')}
    if (!filters.length) delete newParams.offerFilters
    updateLocation(newParams, {
      basePath: pathname,
      method: 'replace',
      mergeWithCurrentParams: false,
      state: {overlay: overlayState}
    })
  }

  /**
   * Toggle a single filter
   */
  const toggleFilter = (filterId: FilterKey, source: FilterSource) => {
    const newFilters = new Set(activeOffersFilters)
    newFilters.delete(filterId) || newFilters.add(filterId)
    setFilters(Array.from(newFilters), source)
  }

  return {
    activeOffersFilters,
    setFilters,
    toggleFilter
  }
}
